
import React from "react";
import { PlusCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ContaBancaria } from "@/types/financeiro";
import ContaItem from "./ContaItem";

interface ListaContasProps {
  contas: ContaBancaria[];
  adicionarConta: () => void;
  isSaving: boolean;
}

const ListaContas: React.FC<ListaContasProps> = ({ contas, adicionarConta, isSaving }) => {
  return (
    <div className="divide-y divide-gray-100">
      {contas.length > 0 ? (
        <>
          {contas.map((conta) => (
            <ContaItem key={conta.id} conta={conta} />
          ))}
        </>
      ) : (
        <div className="text-center py-4 text-gray-500">
          <p className="mb-2 text-xs">Nenhuma conta bancária cadastrada</p>
        </div>
      )}
      
      <div className="pt-3 text-center">
        <Button 
          variant="ghost" 
          size="sm" 
          className="text-gray-500 hover:text-gray-600 hover:bg-gray-50 text-xs"
          onClick={adicionarConta}
          disabled={isSaving}
        >
          <PlusCircle className="h-3 w-3 mr-1" /> Adicionar conta
        </Button>
      </div>
    </div>
  );
};

export default ListaContas;
